// extracted by mini-css-extract-plugin
module.exports = {"textProgress":"TextProgress_textProgress__1OOhb","neon":"TextProgress_neon__22XhF"};